"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);






















 const DEFAULT_FILTERS = { range: { preset: '30d' }, actions: [] }; exports.DEFAULT_FILTERS = DEFAULT_FILTERS

 const DATE_PRESETS = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
  { value: '12m', label: 'Last 12 months' },
]; exports.DATE_PRESETS = DATE_PRESETS

 const SUPPORT_NAME = 'BloomText Support'; exports.SUPPORT_NAME = SUPPORT_NAME
 const SYSTEM_NAME = 'System (API keys)'; exports.SYSTEM_NAME = SYSTEM_NAME

const DAY = 'YYYY-MM-DD'

// Each preset ends with today, in the viewer's time zone; To is exclusive.
const presetStart = (preset, end) => {
  switch (preset) {
    case 'today': return end.clone().subtract(1, 'day')
    case '7d': return end.clone().subtract(7, 'days')
    case '30d': return end.clone().subtract(30, 'days')
    case '90d': return end.clone().subtract(90, 'days')
    case '12m': return end.clone().subtract(12, 'months')
  }
}

 const rangeBounds = (range, now = _moment2.default.call(void 0, )) => {
  if (range.preset === 'custom') {
    return {
      from: _moment2.default.call(void 0, range.from, DAY).startOf('day'),
      to: _moment2.default.call(void 0, range.to, DAY).startOf('day').add(1, 'day'),
    }
  }
  const to = now.clone().startOf('day').add(1, 'day')
  return { from: presetStart(range.preset, to), to }
}; exports.rangeBounds = rangeBounds

 const rangeLabel = (range) => {
  if (range.preset !== 'custom') return _nullishCoalesce(_optionalChain([exports.DATE_PRESETS, 'access', _ => _.find, 'call', _2 => _2(p => p.value === range.preset), 'optionalAccess', _3 => _3.label]), () => ( ''))
  const from = _moment2.default.call(void 0, range.from, DAY)
  const to = _moment2.default.call(void 0, range.to, DAY)
  const sameYear = from.year() === to.year() && to.year() === _moment2.default.call(void 0, ).year()
  const f = sameYear ? 'MMM D' : 'MMM D, YYYY'
  return `${from.format(f)} – ${to.format(f)}`
}; exports.rangeLabel = rangeLabel

// What ListAuditEvents and ExportAuditLog are asked for.
 const auditRequest = (orgKey, f, now = _moment2.default.call(void 0, )) => {
  const { from, to } = exports.rangeBounds.call(void 0, f.range, now)
  return {
    OrgKey: orgKey,
    From: from.toISOString(),
    To: to.toISOString(),
    ...f.orgKey && { OrgKeys: [f.orgKey] },
    ..._optionalChain([f, 'access', _4 => _4.person, 'optionalAccess', _5 => _5.kind]) === 'user' && { ActorUserKeys: [f.person.userKey] },
    ..._optionalChain([f, 'access', _6 => _6.person, 'optionalAccess', _7 => _7.kind]) === 'support' && { Support: true },
    ..._optionalChain([f, 'access', _8 => _8.person, 'optionalAccess', _9 => _9.kind]) === 'system' && { System: true },
    ...f.actions.length > 0 && { Actions: f.actions },
    ...f.patient && { PatientKey: f.patient.patientKey },
  }
}; exports.auditRequest = auditRequest

 const hasFilters = (f) =>
  f.range.preset !== '30d' || !!f.orgKey || !!f.person || f.actions.length > 0 || !!f.patient; exports.hasFilters = hasFilters
